import {CreateProfileBloggerFormField} from "../types/create-profile-blogger-modal.types";

export const createProfileBloggerModalName = 'create-profile-blogger';

export const createProfilesBloggerFormFields: Array<CreateProfileBloggerFormField> = [
  {
    label: 'Ссылка на профиль',
    fieldName: 'url'
  },
];
